import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * `withdrawn`: was sent, the company withdrew it in this session to make changes.
 * `signing`: the company started signing but has not signed; nothing is sent.
 */
export type ContractEditBannerStatus = 'draft' | 'signing' | 'sent' | 'signed' | 'withdrawn';

interface ContractEditBannerProps {
  status: ContractEditBannerStatus;
  /** When the contract was sent for signing (ISO); shown in the "sent" title. */
  sentAt?: string | null;
}

const ICONS: Record<ContractEditBannerStatus, string> = {
  draft: 'feather-edit-3',
  signing: 'feather-edit-3',
  sent: 'feather-send',
  signed: 'feather-lock',
  withdrawn: 'feather-rotate-ccw',
};

/** Edit mode: the contract's state and what editing it means, above the step content. */
export function ContractEditBanner({ status, sentAt }: ContractEditBannerProps) {
  const { t } = useTranslation();
  const date = sentAt ? new Date(sentAt).toLocaleDateString('sv-SE', { day: 'numeric', month: 'long' }) : '';
  const title =
    status === 'sent' && date
      ? t('contracts.wizard.edit.banner.sentTitleWithDate', { date })
      : t(`contracts.wizard.edit.banner.${status}Title`);

  return (
    <div className={`contract-wizard-banner is-${status}`} role="status">
      <i className={`${ICONS[status]} contract-wizard-banner-icon`} aria-hidden="true"></i>
      <div>
        <span className="contract-wizard-status-chip">{t(`contracts.wizard.edit.status.${status}`)}</span>
        <p className="contract-wizard-banner-title">{title}</p>
        <p className="contract-wizard-banner-text">{t(`contracts.wizard.edit.banner.${status}Text`)}</p>
      </div>
    </div>
  );
}

export default ContractEditBanner;
